














































import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseHelpMessage from '../base-help-message/_base-help-message.vue';
import BaseH3 from '../base-headings/_base-h3.vue';
import BaseParagraph from '../base-paragraph/_base-paragraph.vue';
import type { DropzoneLocalization } from './types/dropzone-localization';
import InvalidIllustration from './assets/not-supported.svg';
import DefaultIllustration from './assets/image-file.svg';

@Component({
  name: 'BaseDropzone',
  components: {
    BaseHelpMessage,
    DefaultIllustration,
    InvalidIllustration,
    BaseH3,
    BaseParagraph,
  },
})
export default class BaseDropzone extends Vue {
  @Prop({ default: false }) error: boolean;
  @Prop({ default: '' }) helpMessage: string;
  @Prop() acceptedFileTypes: string;
  @Prop() image: string;
  @Prop() maxSize: number;
  @Prop() disabled: boolean;
  @Prop() localization!: DropzoneLocalization;
  @Prop({ default: false }) multiple: boolean;

  internalError = false;
  internalHelpMessage = '';
  inputValue = '';
  inputFile: File = null;
  validFile = true;

  get description(): string {
    const acceptedFileTypesString: string = this.acceptedFileTypes
      ? `${this.localization.recommended_file_types}: ${this.acceptedFileTypes
          .replace(/\./g, ' ')
          .toUpperCase()} -`
      : '';
    const descriptionString = `${acceptedFileTypesString} ${this.localization.max_file_size} ${this.maxSize} MB`;
    return descriptionString.trim();
  }

  handleMultipleFiles(files: FileList): void {
    const validFiles = [];
    const invalidFiles = [];

    for (let index = 0; index < files.length; index++) {
      const validFile = this.validateFileType(files[index]);
      if (!validFile) {
        invalidFiles.push(files[index]);
      } else {
        validFiles.push(files[index]);
      }
    }

    if (invalidFiles.length) {
      this.$emit('invalidFile', invalidFiles);
    }
    if (validFiles.length) {
      this.$emit('selectFile', validFiles);
    }
  }

  handleFileInput(event: Event) {
    if (this.disabled) {
      return;
    }
    const { files } = event.target as HTMLInputElement;

    if (!files) {
      return;
    }

    if (this.multiple) {
      this.handleMultipleFiles(files);
      return;
    }

    this.inputFile = files[0];
    this.validFile = this.validateFileType(this.inputFile);

    if (!this.inputFile || !this.validFile) {
      this.$emit('invalidFile');
      return;
    }
    this.$emit('selectFile', this.inputFile);
    this.inputValue = '';
  }

  handleDrop(event: DragEvent) {
    if (this.disabled) {
      return;
    }
    if (!event.dataTransfer) {
      return;
    }

    if (this.multiple) {
      this.handleMultipleFiles(event.dataTransfer.files);
      return;
    }

    this.inputFile = event.dataTransfer.files[0];

    this.validFile = this.validateFileType(this.inputFile);

    if (!this.inputFile || !this.validFile) {
      this.$emit('invalidFile');
      return;
    }
    this.$emit('selectFile', this.inputFile);
  }

  created() {
    this.internalHelpMessage = this.helpMessage;
  }

  validateFileType(inputFile: File): boolean {
    const fileName: string = inputFile?.name || '';
    const dotIndex: number = fileName.lastIndexOf('.');
    if (dotIndex < 0) {
      return false;
    }
    const fileType: string = fileName.substr(dotIndex).toLowerCase();

    return this.acceptedFileTypes ? this.acceptedFileTypes.includes(fileType) : true;
  }

  get validUploadedFile(): boolean {
    return !!this.inputFile && this.validFile;
  }
}
